import reauthenticateSaga from './reauthenticateSaga';
import resetPasswordSaga from './resetPasswordSaga';
import sendTourReviewSaga from './sendTourReviewSaga';
import fetchTourSaga from './fetchTourSaga';

export default [...reauthenticateSaga, ...resetPasswordSaga, ...sendTourReviewSaga, ...fetchTourSaga];
